import React from "react";
import { Link } from "gatsby";
import "../styles/Sidebar.css";
import { FaTimes } from "react-icons/fa";
// Dropdown Icons
import corporativoIcon from "../images/corporativo-icon.svg";
import nosotrosIcon from "../images/nosotros.svg";
import turismoIcon from "../images/turismo-icon.svg";
import destinosIcon from "../images/destinos-icon.svg";
import promocionesIcon from "../images/promociones-icon.svg";
import infoIcon from "../images/info-icon.svg";
import contactIcon from "../images/contact-icon.svg";
import phoneIcon from "../images/phone-sidebar.svg";

const SideBar = ({ isOpen, toggleSidebar }) => {
  return (
    <aside className={isOpen ? "sidebar show-sidebar" : "sidebar"}>
      <button aria-label="Hamburger close btn" className="close-btn" type="button" onClick={toggleSidebar}>
        <FaTimes className="btn-close-style" />
      </button>
      <div className="side-container">
        <div className="side-container-title">
          <span>Compañia</span>
        </div>
        <ul className="side-page-list">
          <div className="dropdown-columns-align-sidebar">
            <li className="menu-viajes-links">
              <img
                src={nosotrosIcon}
                className="dropdown-icons"
                alt="tasking icon"
                loading="eager"
              />
              <Link
                to="/nosotros/"
                onClick={toggleSidebar}
                activeClassName="active-page"
              >
                Nosotros
              </Link>
            </li>
          </div>
          <div className="dropdown-columns-align-sidebar">
            <li className="menu-viajes-links">
              <img
                src={turismoIcon}
                className="dropdown-icons-scheduling"
                alt="bridge portal icon"
                loading="eager"
              />
              <Link
                to="/turismo/"
                onClick={toggleSidebar}
                activeClassName="active-page"
              >
                Turismo
              </Link>
            </li>
          </div>
        </ul>
        <div className="side-container-title">
          <span>Viajes</span>
        </div>
        <ul className="side-page-list">
          <div className="dropdown-columns-align-sidebar">
            <li className="menu-viajes-links">
              <img
                src={destinosIcon}
                className="dropdown-icons"
                alt="tasking icon"
                loading="eager"
              />
              <Link
                to="/destinos/"
                onClick={toggleSidebar}
                activeClassName="active-page"
              >
                Destinos
              </Link>
            </li>
          </div>
          <div className="dropdown-columns-align-sidebar">
            <li className="menu-viajes-links">
              <img
                src={promocionesIcon}
                className="dropdown-icons"
                alt="tasking icon"
                loading="eager"
              />
              <Link
                to="/promociones/"
                onClick={toggleSidebar}
                activeClassName="active-page"
              >
                Promociones
              </Link>
            </li>
          </div>
          <div className="dropdown-columns-align-sidebar">
            <li className="menu-viajes-links">
              <img
                src={infoIcon}
                className="dropdown-icons"
                alt="tasking icon"
                loading="eager"
              />
              <Link
                to="/info-viajes/"
                onClick={toggleSidebar}
                activeClassName="active-page"
              >
                Info Viajes
              </Link>
            </li>
          </div>
        </ul>
        <div className="side-container-title">
          <span>Soporte</span>
        </div>
        <ul className="side-page-list">
          <div className="dropdown-columns-align-sidebar">
            <li className="menu-viajes-links">
              <img
                src={contactIcon}
                className="dropdown-icons"
                alt="tasking icon"
                loading="eager"
              />
              <Link
                to="/contactanos/"
                onClick={toggleSidebar}
                activeClassName="active-page"
              >
                Contactanos
              </Link>
            </li>
          </div>
          <div className="dropdown-columns-align-sidebar">
            <li className="menu-viajes-links">
              <a href="tel:+582122092800" target="_blank" rel="noreferrer">
                <strong>Telefono:</strong> 02122092800
              </a>
            </li>
          </div>
          <div className="dropdown-columns-align-sidebar">
            <li className="menu-viajes-links">
              <a href="info@omega.com.ve" target="_blank" rel="noreferrer">
                <strong>Email:</strong> info@omega.com.ve
              </a>
            </li>
          </div>
        </ul>
      </div>
    </aside>
  );
};

export default SideBar;
